export default {
  title: 'Disfruta de la mejor experiencia en nuestra app',
  description: 'Ahorra tiempo, gana recompensas, recibe notificaciones de ofertas y más',
  buttons: {
    download: 'Abrir la app {{name}}',
  },
};
